<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Modifier Statut</strong>
          </div>
          <b-form>
            <b-form-group
              label="Catégorie"
              label-for="basicSelect"
            >
              <b-form-select
                id="basicSelect"
                :options="categoryOptions"
                v-model="categorySelected"
                :class="{hasError: errors.categorySelected !== ''}"
              ></b-form-select>
              <span class='field-error'>{{ errors.categorySelected }}</span>
            </b-form-group>
            <b-form-group
              description='Libelle du statut vu côté client'
              label='Libelle client'
              label-for='Libelle_front'
            >
              <b-form-input id='libelle_front' type='text' :class="{hasError: errors.libelle_front !== ''}" v-model="libelle_front"></b-form-input>
              <span class='field-error'>{{ errors.libelle_front }}</span>
            </b-form-group>
            <b-form-group
                description='Libelle du statut vu côté gestionnaire'
                label='Libelle gestionnaire'
                label-for='Libelle_bo'
              >
              <b-form-input id='libelle_bo' type='text' :class="{hasError: errors.libelle_bo !== ''}" v-model="libelle_bo"></b-form-input>
              <span class='field-error'>{{ errors.libelle_bo }}</span>
            </b-form-group>
            <b-form-group
                label='Libelle technique'
                label-for='tec_label_bo'
              >
              <b-form-input id='tec_label_bo' type='text' :class="{hasError: errors.libelle_technique !== ''}" v-model="libelle_technique" disabled></b-form-input>
              <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-form-group>
            <b-form-group
                label='Parent'
                label-for='parent_id'>
              <b-form-select v-model="selectedParent" :options="allParents">
                <template v-if="categorySelected === ''" v-slot:first>
                  <b-form-select-option value="needCategory">Veuillez d'abord sélectionner une catégorie</b-form-select-option>
                </template>
                <template v-else v-slot:first>
                  <b-form-select-option value="null">-- Aucun parent --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
            <b-form-group
              label='Critère de priorité'
              label-for='critere_priorite'>
              <b-form-input id='critere_priorite' type='number' min="0" :class="{hasError: errors.critere_priorite !== ''}" v-model="critere_priorite"></b-form-input>
              <span class='field-error'>{{ errors.critere_priorite }}</span>
            </b-form-group>
            <b-form-group
              label='Ordre'
              label-for='ordre'>
              <b-form-input id='ordre' type='number' min="0" v-model="ordre"></b-form-input>
            </b-form-group>
            <b-form-group
              label='Libellé destinataire'
              label-for='libelle_destinataire_ps'>
              <b-form-input id='libelle_destinataire_ps' type='text' :class="{hasError: errors.libelle_destinataire_ps !== ''}" v-model="libelle_destinataire_ps"></b-form-input>
              <span class='field-error'>{{ errors.libelle_destinataire_ps }}</span>
            </b-form-group>
            <b-form-group label="traitement secondaire" label-for="traitement_secondaire">
              <b-form-select
                id="traitement_secondaire"
                :options="traitementOptions"
                v-model="traitementSelected">
              </b-form-select>
            </b-form-group>
            <b-row class="mb-1">
              <b-col sm="6">
                <label for="has_reopen_traitement_secondaire"><strong>Réouvre le dossier dans le traitement secondaire</strong></label>
              </b-col>
              <b-col sm="6">
                <b-form-group>
                  <b-form-checkbox v-model="has_reopen_traitement_secondaire"></b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <b-form-group label="Type">
              <multiselect v-model="types"
                           :class="{hasError: errors.types !== ''}"
                           tag-placeholder="Choisissez un type"
                           placeholder="Choisissez un type"
                           label="name"
                           track-by="id"
                           :options="allTypes"
                           :multiple="true"
                           :taggable="true">
              </multiselect>
              <span class='field-error'>{{ errors.types }}</span>
            </b-form-group>
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des statuts
              </b-button>
              <b-button type="button" @click="saveStatus" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import Multiselect from 'vue-multiselect';

export default {
  data() {
    return {
      libelle_front: '',
      libelle_bo: '',
      libelle_technique: '',
      selectedParent: null,
      allParents: [],
      critere_priorite: '',
      ordre: '',
      libelle_destinataire_ps: '',
      errors: {
        libelle_front: '',
        libelle_bo: '',
        libelle_technique: '',
        categorySelected: '',
        critere_priorite: '',
        libelle_destinataire_ps: '',
        types: '',
      },
      categoryOptions: [],
      categorySelected: '',
      traitementOptions: [],
      traitementSelected: null,
      types: [],
      allTypes: [],
      selectedTypes: [],
      has_reopen_traitement_secondaire: false,
    }
  },
  components: {
    Multiselect,
  },
  watch: {
    categorySelected: function() {
      this.getParents(this.categorySelected)
    },
    types: function () {
      if (this.types) {
        this.selectedTypes = this.types.map(item => item.id);
      } else {
        this.selectedTypes = [];
      }
    },
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl()
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken()
    this.$axios.defaults.headers.common["Accept"] = "application/json"
    this.$axios.defaults.headers.common["Provider"] = getProvider()
    this.allCategory()
    if (this.$route.query.category) {
      this.selectedCategory = this.$route.query.category
      this.getParents(this.selectedCategory)
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.populateStatus();
    }
    this.getTraitementsSecondaires();
    await this.getTypes();
    this.populateTypes();
  },
  methods: {
    allCategory() {
      this.$axios
        .get("/administration/categories")
        .then(response => {
          let categories = response.data.categories;
          for (let i = 0; i < categories.length; i++) {
            this.categoryOptions.push({
              text: categories[i].libelle,
              value: categories[i].id
            });
          }
        });
    },
    getParents(categoryId) {
      // console.log('dans getParents')
      // Récupérer la liste de tous les statuts parents pour cette catégorie
      this.$axios
        .get('/administration/statuts/getParents/'+categoryId)
        .then(response => {
          // console.log('getParents done')
          let statuts = response.data.status;
          for (let statut of statuts) {
            this.allParents.push({
              text: statut.libelle_bo+'('+statut.id+')',
              value: statut.id
            })
          }
        })
        .catch(function(error) {
        })
    },
    async populateStatus() {
      this.$store.commit("IS_LOADING", true)
      let statusId = this.$route.params.id
      let self = this
      await this.$axios
        .get("/administration/statuts/edit/" + statusId)
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          let statuts = response.data.statusParent;
          for (let statut of statuts) {
            this.allParents.push({
              text: statut.libelle_bo+'('+statut.id+')',
              value: statut.id
            })
          }
          for (let type of response.data.status.types) {
            this.selectedTypes.push({
              id: type.id,
              name: type.libelle
            });
          }
          this.libelle_front = response.data.status.libelle_front;
          this.libelle_bo = response.data.status.libelle_bo;
          this.libelle_technique = response.data.status.libelle_technique;
          this.categorySelected = response.data.status.categorie_status_id;
          this.selectedParent = response.data.status.parent_id;
          this.traitementSelected = response.data.status.traitement_ps_id;
          this.critere_priorite = response.data.status.critere_priorite;
          this.ordre = response.data.status.ordre;
          this.libelle_destinataire_ps = response.data.status.libelle_destinataire_ps;
          this.has_reopen_traitement_secondaire = response.data.status.has_reopen_traitement_secondaire;
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit("IS_LOADING", false)
          if (
            error.response &&
            error.response.status === 404 &&
            self != undefined
          ) {
            self.$router.push({ path: "/administration/statuts" })
            self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: "Le statut avec l'id " + id + " n'existe pas",
              showConfirmButton: false,
              timer: 5000
            })
          }
        })
    },
    saveStatus() {
      if (this.validateData()) {
        this.$store.commit("IS_LOADING", true)
        let self = this
        let dataPost = {}
        let statusId = this.$route.params.id
        dataPost.libelle_front = this.libelle_front
        dataPost.libelle_bo = this.libelle_bo
        dataPost.libelle_technique = this.libelle_technique
        dataPost.parent_id = this.selectedParent
        dataPost.category = this.categorySelected;
        dataPost.traitement_ps_id = this.traitementSelected;
        dataPost.critere_priorite = this.critere_priorite;
        dataPost.ordre = this.ordre;
        dataPost.libelle_destinataire_ps = this.libelle_destinataire_ps;
        dataPost.type_status  = this.types.map((type) => type.id);
        dataPost.has_reopen_traitement_secondaire  = this.has_reopen_traitement_secondaire;
        this.$axios
          .put("/administration/statuts/" + statusId, dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false)
            this.$swal({
              position: "top",
              type: "success",
              title: "Modification avec succès",
              text: 'Le statut ' + dataPost.libelle_bo + ' a bien été modifié',
              showConfirmButton: false,
              timer: 5000
            })
            this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false)
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 5000
            })
          })
      }
    },
    returnBack() {
      this.$router.push({ path: '/administration/statuts', query: { category: this.$route.query.category}})
    },
    formatDate(textDate) {
      let date =
        textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : ""
      return date
    },
    validateData() {
      this.clearErrors();
      const typeStatus = this.types.map((type) => type.id);
      let regAlpha = this.$store.getters.getRegAlpha
      let regAlphaUnderscore = this.$store.getters.getRegAlphaUnderscore
      let valid = true

      if (this.libelle_front.trim() === ''){
        this.errors.libelle_front = 'Le libelle pour le client est obligatoire'
        valid= false
      }
      if (this.libelle_bo.trim() === ''){
        this.errors.libelle_bo = 'Le libelle pour le gestionnaire est obligatoire'
        valid= false
      }
      if (this.libelle_technique.trim() === '') {
        this.errors.libelle_technique = 'Le libelle technique est obligatoire'
        valid= false
      }
      if (this.categorySelected === ''){
        this.errors.categorySelected = 'La catégorie est obligatoire'
        valid= false
      }
      if (typeStatus.length === 0){
        this.errors.types = 'Vous devez choisir au moins un type'
        valid= false
      }

      return valid;
    },
    clearErrors() {
      this.errors.libelle_front = ''
      this.errors.libelle_bo = ''
      this.errors.libelle_technique = ''
      this.errors.categorySelected = ''
    },
    clearForm() {
      this.libelle_front = ''
      this.libelle_bo = ''
      this.libelle_technique = ''
      this.selectedParent = 'needCategory';
      this.categorySelected = '';
      this.critere_priorite = '';
      this.ordre = '';
      this.libelle_destinataire_ps = '';
      this.traitement_ps_id  = null;
    },
    getTraitementsSecondaires() {
      this.$axios
        .get("/administration/traitements_secondaires")
        .then(response => {
          const traitements = response.data.data ? response.data.data : [];
          for (let i = 0; i < traitements.length; i++) {
            this.traitementOptions.push({
              text: traitements[i].libelle,
              value: traitements[i].id
            });
          }
        })
        .catch((error) => {
          console.log(error)
        });
    },
    async getTypes() {
      let self = this
      this.$store.commit("IS_LOADING", true)
      await this.$axios
        .get("/administration/statuts/typesStatus")
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          for(let type of response.data.data){
            this.allTypes.push({id: type.id, name: type.libelle})
          }
        })
        .catch(function() {
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support",
            showConfirmButton: false,
            timer: 5000
          })
        });
    },
    populateTypes() {
      this.types = [];
      for (let selectedType of this.selectedTypes) {
        let name = "";
        for (let type of this.allTypes) {
          if (type.id === parseInt(selectedType.id)) {
            name = type.name;
          }
        }
        this.types.push({id: selectedType.id, name: name});
      }
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
